import { AppointmentWUT } from '../fields/appointment/appointment/appointment-wut';
import { default as BookingsAddress } from '../fields/bookings-address/bookings-address/bookings-address';
import { BookingsEmailWUT } from '../fields/bookings-email/bookings-email/bookings-email-wut';
import { BookingsFirstNameWUT } from '../fields/bookings-first-name/bookings-first-name/bookings-first-name-wut';
import { BookingsHeaderWUT } from '../fields/bookings-header/bookings-header/bookings-header-wut';
import { BookingsLastNameWUT } from '../fields/bookings-last-name/bookings-last-name/bookings-last-name-wut';
import { BookingsLoginBarWUT } from '../fields/bookings-login-bar/bookings-login-bar/bookings-login-bar-wut';
import { BookingsPhoneWUT } from '../fields/bookings-phone/bookings-phone/bookings-phone-wut';
import { BookingsRichTextWUT } from '../fields/bookings-rich-text/bookings-rich-text/bookings-rich-text-wut';
import { CheckboxGroupWUT } from '../fields/checkbox-group/checkbox-group/checkbox-group-wut';
import { CheckboxWUT } from '../fields/checkbox/checkbox/checkbox-wut';
import { ContactsAddressWUT } from '../fields/contacts-address/contacts-address/contacts-address-wut';
import { ContactsBirthdateWUT } from '../fields/contacts-birthdate/contacts-birthdate/contacts-birthdate-wut';
import { ContactsCompanyWUT } from '../fields/contacts-company/contacts-company/contacts-company-wut';
import { ContactsEmailWUT } from '../fields/contacts-email/contacts-email/contacts-email-wut';
import { ContactsFirstNameWUT } from '../fields/contacts-first-name/contacts-first-name/contacts-first-name-wut';
import { ContactsLastNameWUT } from '../fields/contacts-last-name/contacts-last-name/contacts-last-name-wut';
import { ContactsPhoneWUT } from '../fields/contacts-phone/contacts-phone/contacts-phone-wut';
import { ContactsPositionWUT } from '../fields/contacts-position/contacts-position/contacts-position-wut';
import { ContactsSubscribeWUT } from '../fields/contacts-subscribe/contacts-subscribe/contacts-subscribe-wut';
import { ContactsTaxIdWUT } from '../fields/contacts-tax-id/contacts-tax-id/contacts-tax-id-wut';
import { DateInputWUT } from '../fields/date-input/date-input/date-input-wut';
import { DatePickerWUT } from '../fields/date-picker/date-picker/date-picker-wut';
import { DateTimeInputWUT } from '../fields/date-time-input/date-time-input/date-time-input-wut';
import { DextCheckboxGroupWUT } from '../fields/dext-checkbox-group/dext-checkbox-group/dext-checkbox-group-wut';
import { DextCheckboxWUT } from '../fields/dext-checkbox/dext-checkbox/dext-checkbox-wut';
import { DextDatePickerWUT } from '../fields/dext-date-picker/dext-date-picker/dext-date-picker-wut';
import { DextDropdownWUT } from '../fields/dext-dropdown/dext-dropdown/dext-dropdown-wut';
import { DextEmailWUT } from '../fields/dext-email/dext-email/dext-email-wut';
import { DextNumberInputWUT } from '../fields/dext-number-input/dext-number-input/dext-number-input-wut';
import { DextPhoneWUT } from '../fields/dext-phone/dext-phone/dext-phone-wut';
import { DextRadioGroupWUT } from '../fields/dext-radio-group/dext-radio-group/dext-radio-group-wut';
import { DextRatingInputWUT } from '../fields/dext-rating-input/dext-rating-input/dext-rating-input-wut';
import { DextTagsWUT } from '../fields/dext-tags/dext-tags/dext-tags-wut';
import { DextTextAreaWUT } from '../fields/dext-text-area/dext-text-area/dext-text-area-wut';
import { DextTextInputWUT } from '../fields/dext-text-input/dext-text-input/dext-text-input-wut';
import { DextUrlInputWUT } from '../fields/dext-url-input/dext-url-input/dext-url-input-wut';
import { DonationWUT } from '../fields/donation/donation/donation-wut';
import { DropdownWUT } from '../fields/dropdown/dropdown/dropdown-wut';
import { EcomAdditionalInfoWUT } from '../fields/ecom-additional-info/ecom-additional-info/ecom-additional-info-wut';
import { default as EcomAddress } from '../fields/ecom-address/ecom-address/ecom-address';
import { EcomCompanyNameWUT } from '../fields/ecom-company-name/ecom-company-name/ecom-company-name-wut';
import { EcomEmailWUT } from '../fields/ecom-email/ecom-email/ecom-email-wut';
import { EcomFullName } from '../fields/ecom-full-name/ecom-full-name';
import { default as EcomHeader } from '../fields/ecom-header/ecom-header';
import { EcomPhoneWUT } from '../fields/ecom-phone/ecom-phone/ecom-phone-wut';
import { EcomSubscriptionCheckboxWUT } from '../fields/ecom-subscription-checkbox/ecom-subscription-checkbox/ecom-subscription-checkbox-wut';
import { FileUploadWUT } from '../fields/file-upload/file-upload/file-upload-wut';
import { FixedPaymentWUT } from '../fields/fixed-payment/fixed-payment/fixed-payment-wut';
import { default as FullName } from '../fields/full-name/full-name/full-name';
import { FullNameFirstNameWUT } from '../fields/full-name-first-name/full-name-first-name/full-name-first-name-wut';
import { FullNameLastNameWUT } from '../fields/full-name-last-name/full-name-last-name/full-name-last-name-wut';
import { HeaderWUT } from '../fields/header/header/header-wut';
import { MlaAddressLineWUT } from '../fields/mla-address-line/mla-address-line/mla-address-line-wut';
import { MlaAddressLine2WUT } from '../fields/mla-address-line-2/mla-address-line-2/mla-address-line-2-wut';
import { MlaApartmentWUT } from '../fields/mla-apartment/mla-apartment/mla-apartment-wut';
import { MlaCityWUT } from '../fields/mla-city/mla-city/mla-city-wut';
import { MlaCountryWUT } from '../fields/mla-country/mla-country/mla-country-wut';
import { MlaPostalCodeWUT } from '../fields/mla-postal-code/mla-postal-code';
import { MlaStreetNumberWUT } from '../fields/mla-street-number/mla-street-number/mla-street-number-wut';
import { MlaSubdivisionWUT } from '../fields/mla-subdivision/mla-subdivision';
import { MlaStreetNameWUT } from '../fields/mla-street-name/mla-street-name';
import { default as MultilineAddress } from '../fields/multiline-address/multiline-address/multiline-address';
import { default as NestedForm } from '../fields/nested-form/nested-form/nested-form';
import { NumberInputWUT } from '../fields/number-input/number-input/number-input-wut';
import { PaymentInputWUT } from '../fields/payment-input/payment-input/payment-input-wut';
import { ProductListWUT } from '../fields/product-list/product-list/product-list-wut';
import { default as QuizFileUpload } from '../fields/quiz-file-upload/quiz-file-upload';
import { QuizImageChoiceWUT } from '../fields/quiz-image-choice/quiz-image-choice/quiz-image-choice-wut';
import { QuizLongTextWUT } from '../fields/quiz-long-text/quiz-long-text/quiz-long-text-wut';
import { QuizMultiChoiceWUT } from '../fields/quiz-multi-choice/quiz-multi-choice/quiz-multi-choice-wut';
import { QuizNumberWUT } from '../fields/quiz-number/quiz-number/quiz-number-wut';
import { QuizShortTextWUT } from '../fields/quiz-short-text/quiz-short-text/quiz-short-text-wut';
import { QuizSingleChoiceWUT } from '../fields/quiz-single-choice/quiz-single-choice/quiz-single-choice-wut';
import { RadioGroupWUT } from '../fields/radio-group/radio-group/radio-group-wut';
import { RatingInputWUT } from '../fields/rating-input/rating-input/rating-input-wut';
import { RichTextWUT } from '../fields/rich-text/rich-text/rich-text-wut';
import { SignatureWUT } from '../fields/signature/signature/signature-wut';
import { SubmitButtonWUT } from '../fields/submit-button/submit-button/submit-button-wut';
import { TagsWUT } from '../fields/tags/tags/tags-wut';
import { TextAreaWUT } from '../fields/text-area/text-area/text-area-wut';
import { TextInputWUT } from '../fields/text-input/text-input/text-input-wut';
import { TimeInputWUT } from '../fields/time-input/time-input/time-input-wut';
import { UrlInputWUT } from '../fields/url-input/url-input/url-input-wut';
import { VatId } from '../fields/vat-id/vat-id';
import { FIELD_TYPES } from '../constants/field-types';
import { ServiceDropdownWUT } from '../fields/service-dropdown/service-dropdown/service-dropdown-wut';
export { EcomAdditionalInfoWUT, RichTextWUT, HeaderWUT, SubmitButtonWUT, CheckboxWUT, DateInputWUT, DateTimeInputWUT, TimeInputWUT, DatePickerWUT, DropdownWUT, RadioGroupWUT, CheckboxGroupWUT, NumberInputWUT, QuizNumberWUT, QuizShortTextWUT, QuizLongTextWUT, QuizMultiChoiceWUT, QuizImageChoiceWUT, QuizSingleChoiceWUT, QuizFileUpload, FileUploadWUT, ContactsEmailWUT, ContactsBirthdateWUT, ContactsPhoneWUT, UrlInputWUT, ContactsCompanyWUT, ContactsPositionWUT, ContactsTaxIdWUT, ContactsFirstNameWUT, ContactsLastNameWUT, ContactsAddressWUT, TextInputWUT, TextAreaWUT, ContactsSubscribeWUT, MultilineAddress, NestedForm, MlaCountryWUT, MlaCityWUT, MlaAddressLineWUT, MlaAddressLine2WUT, MlaPostalCodeWUT, MlaSubdivisionWUT, MlaStreetNameWUT, MlaStreetNumberWUT, MlaApartmentWUT, FullName, FullNameFirstNameWUT, FullNameLastNameWUT, VatId, DextTextInputWUT, DextTextAreaWUT, DextDropdownWUT, DextRadioGroupWUT, DextUrlInputWUT, DextEmailWUT, DextPhoneWUT, DextNumberInputWUT, DextCheckboxWUT, DextCheckboxGroupWUT, DextRatingInputWUT, DextDatePickerWUT, DextTagsWUT, EcomAddress, EcomFullName, EcomPhoneWUT, EcomCompanyNameWUT, EcomEmailWUT, EcomSubscriptionCheckboxWUT, EcomHeader, ProductListWUT, DonationWUT, SignatureWUT, RatingInputWUT, TagsWUT, PaymentInputWUT, FixedPaymentWUT, BookingsFirstNameWUT, BookingsLastNameWUT, BookingsEmailWUT, BookingsPhoneWUT, BookingsAddress, BookingsHeaderWUT, BookingsRichTextWUT, BookingsLoginBarWUT, AppointmentWUT, ServiceDropdownWUT };
export const INPUT_ELEMENTS = {
  [FIELD_TYPES.ECOM_ADDITIONAL_INFO]: EcomAdditionalInfoWUT,
  [FIELD_TYPES.RICH_TEXT]: RichTextWUT,
  [FIELD_TYPES.HEADER]: HeaderWUT,
  [FIELD_TYPES.SUBMIT_BUTTON]: SubmitButtonWUT,
  [FIELD_TYPES.CHECKBOX]: CheckboxWUT,
  [FIELD_TYPES.DATE_INPUT]: DateInputWUT,
  [FIELD_TYPES.DATE_TIME_INPUT]: DateTimeInputWUT,
  [FIELD_TYPES.TIME_INPUT]: TimeInputWUT,
  [FIELD_TYPES.DATE_PICKER]: DatePickerWUT,
  [FIELD_TYPES.DROPDOWN]: DropdownWUT,
  [FIELD_TYPES.RADIO_GROUP]: RadioGroupWUT,
  [FIELD_TYPES.CHECKBOX_GROUP]: CheckboxGroupWUT,
  [FIELD_TYPES.NUMBER_INPUT]: NumberInputWUT,
  [FIELD_TYPES.QUIZ_NUMBER]: QuizNumberWUT,
  [FIELD_TYPES.QUIZ_SHORT_TEXT]: QuizShortTextWUT,
  [FIELD_TYPES.QUIZ_LONG_TEXT]: QuizLongTextWUT,
  [FIELD_TYPES.QUIZ_MULTI_CHOICE]: QuizMultiChoiceWUT,
  [FIELD_TYPES.QUIZ_IMAGE_CHOICE]: QuizImageChoiceWUT,
  [FIELD_TYPES.QUIZ_SINGLE_CHOICE]: QuizSingleChoiceWUT,
  [FIELD_TYPES.QUIZ_FILE_UPLOAD]: QuizFileUpload,
  [FIELD_TYPES.FILE_UPLOAD]: FileUploadWUT,
  [FIELD_TYPES.CONTACTS_EMAIL]: ContactsEmailWUT,
  [FIELD_TYPES.CONTACTS_BIRTHDATE]: ContactsBirthdateWUT,
  [FIELD_TYPES.CONTACTS_PHONE]: ContactsPhoneWUT,
  [FIELD_TYPES.URL_INPUT]: UrlInputWUT,
  [FIELD_TYPES.CONTACTS_COMPANY]: ContactsCompanyWUT,
  [FIELD_TYPES.CONTACTS_POSITION]: ContactsPositionWUT,
  [FIELD_TYPES.CONTACTS_TAX_ID]: ContactsTaxIdWUT,
  [FIELD_TYPES.CONTACTS_FIRST_NAME]: ContactsFirstNameWUT,
  [FIELD_TYPES.CONTACTS_LAST_NAME]: ContactsLastNameWUT,
  [FIELD_TYPES.CONTACTS_ADDRESS]: ContactsAddressWUT,
  [FIELD_TYPES.TEXT_INPUT]: TextInputWUT,
  [FIELD_TYPES.TEXT_AREA]: TextAreaWUT,
  [FIELD_TYPES.CONTACTS_SUBSCRIBE]: ContactsSubscribeWUT,
  [FIELD_TYPES.MULTILINE_ADDRESS]: MultilineAddress,
  [FIELD_TYPES.NESTED_FORM]: NestedForm,
  [FIELD_TYPES.MLA_COUNTRY]: MlaCountryWUT,
  [FIELD_TYPES.MLA_CITY]: MlaCityWUT,
  [FIELD_TYPES.MLA_ADDRESS_LINE]: MlaAddressLineWUT,
  [FIELD_TYPES.MLA_ADDRESS_LINE_2]: MlaAddressLine2WUT,
  [FIELD_TYPES.MLA_POSTAL_CODE]: MlaPostalCodeWUT,
  [FIELD_TYPES.MLA_SUBDIVISION]: MlaSubdivisionWUT,
  [FIELD_TYPES.MLA_STREET_NAME]: MlaStreetNameWUT,
  [FIELD_TYPES.MLA_STREET_NUMBER]: MlaStreetNumberWUT,
  [FIELD_TYPES.MLA_APARTMENT]: MlaApartmentWUT,
  [FIELD_TYPES.FULL_NAME]: FullName,
  [FIELD_TYPES.FULL_NAME_FIRST_NAME]: FullNameFirstNameWUT,
  [FIELD_TYPES.FULL_NAME_LAST_NAME]: FullNameLastNameWUT,
  [FIELD_TYPES.VAT_ID]: VatId,
  [FIELD_TYPES.DEXT_TEXT_INPUT]: DextTextInputWUT,
  [FIELD_TYPES.DEXT_TEXT_AREA]: DextTextAreaWUT,
  [FIELD_TYPES.DEXT_DROPDOWN]: DextDropdownWUT,
  [FIELD_TYPES.DEXT_RADIO_GROUP]: DextRadioGroupWUT,
  [FIELD_TYPES.DEXT_URL_INPUT]: DextUrlInputWUT,
  [FIELD_TYPES.DEXT_EMAIL]: DextEmailWUT,
  [FIELD_TYPES.DEXT_PHONE]: DextPhoneWUT,
  [FIELD_TYPES.DEXT_NUMBER_INPUT]: DextNumberInputWUT,
  [FIELD_TYPES.DEXT_CHECKBOX]: DextCheckboxWUT,
  [FIELD_TYPES.DEXT_CHECKBOX_GROUP]: DextCheckboxGroupWUT,
  [FIELD_TYPES.DEXT_RATING_INPUT]: DextRatingInputWUT,
  [FIELD_TYPES.DEXT_DATE_PICKER]: DextDatePickerWUT,
  [FIELD_TYPES.DEXT_TAGS]: DextTagsWUT,
  [FIELD_TYPES.ECOM_ADDRESS]: EcomAddress,
  [FIELD_TYPES.ECOM_FULL_NAME]: EcomFullName,
  [FIELD_TYPES.ECOM_PHONE]: EcomPhoneWUT,
  [FIELD_TYPES.ECOM_COMPANY_NAME]: EcomCompanyNameWUT,
  [FIELD_TYPES.ECOM_EMAIL]: EcomEmailWUT,
  [FIELD_TYPES.ECOM_SUBSCRIPTION]: EcomSubscriptionCheckboxWUT,
  [FIELD_TYPES.ECOM_CONTACT_DETAILS]: EcomHeader,
  [FIELD_TYPES.ECOM_SHIPPING_DETAILS]: EcomHeader,
  [FIELD_TYPES.PRODUCT_LIST]: ProductListWUT,
  [FIELD_TYPES.DONATION]: DonationWUT,
  [FIELD_TYPES.SIGNATURE]: SignatureWUT,
  [FIELD_TYPES.RATING_INPUT]: RatingInputWUT,
  [FIELD_TYPES.TAGS]: TagsWUT,
  [FIELD_TYPES.PAYMENT_INPUT]: PaymentInputWUT,
  [FIELD_TYPES.FIXED_PAYMENT]: FixedPaymentWUT,
  [FIELD_TYPES.BOOKINGS_FIRST_NAME]: BookingsFirstNameWUT,
  [FIELD_TYPES.BOOKINGS_LAST_NAME]: BookingsLastNameWUT,
  [FIELD_TYPES.BOOKINGS_EMAIL]: BookingsEmailWUT,
  [FIELD_TYPES.BOOKINGS_PHONE]: BookingsPhoneWUT,
  [FIELD_TYPES.BOOKINGS_ADDRESS]: BookingsAddress,
  [FIELD_TYPES.BOOKINGS_HEADER]: BookingsHeaderWUT,
  [FIELD_TYPES.BOOKINGS_RICH_TEXT]: BookingsRichTextWUT,
  [FIELD_TYPES.BOOKINGS_LOGIN_BAR]: BookingsLoginBarWUT,
  [FIELD_TYPES.APPOINTMENT]: AppointmentWUT,
  [FIELD_TYPES.SERVICES_DROPDOWN]: ServiceDropdownWUT
};
export * from '../theme';
//# sourceMappingURL=wut.js.map